import Highcharts from 'highcharts';
import HighchartsReact from 'highcharts-react-official';

const PieChartExample = ({ data }: any) => {
  const colors = ['#FF2A00', '#35B1E8'];
  const pieData =
    data?.items?.map((item: any, index: number) => ({
      name: item.Name,
      y: item.Value ?? 0,
      color: colors[index % colors.length], // Assign color cyclically
    })) || [];

  const options = {
    chart: {
      type: 'pie',
      zooming: {
        type: 'xy',
      },
      panning: {
        enabled: true,
        type: 'xy',
      },
      panKey: 'shift',
    },
    title: {
      text: 'Payment Method',
      style: {
        fontSize: '13px',
      },
    },
    subtitle: {
      text: '',
    },
    tooltip: {
      pointFormat: '<b>{point.percentage:.1f}%</b> ({point.y})',
    },
    plotOptions: {
      pie: {
        allowPointSelect: true,
        cursor: 'pointer',
        dataLabels: {
          enabled: true,
          distance: 20,
          format: '{point.name}: {point.y} ({point.percentage:.1f}%)',
          style: {
            fontSize: '0.9rm',
            textOutline: 'none',
          },
        },
      },
    },
    credits: {
      enabled: false,
    },
    series: [
      {
        name: 'Bookings',
        colorByPoint: true,
        data: pieData,
      },
    ],
  };

  return <HighchartsReact highcharts={Highcharts} options={options} />;
};

export default PieChartExample;
